
  import { defineComponent, PropType } from 'vue';

  import TableTree from '@/common/components/redesigned/Table/TableTree/TableTree.vue';
  import { TTableTreeConfig } from '@/common/components/redesigned/Table/types/tableTypes';

  import {
    STATISTICS_PORTAL_ACTIONS_NAME,
    STATISTICS_PORTAL_GETTERS_NAME,
    STATISTICS_PORTAL_MUTATIONS_NAME,
  } from '../../../store/statisticsPortal/name';
  import {
    TPortalAverageVisitsTimeTableItem,
    TStatisticsPortalAverageVisitsTimeChartItem,
    TStatisticsPortalFilter,
  } from '../../../types/statistics/statistics-portal';
  import { TChartBaseConfig } from '../charts/chartTypes';
  import StatisticsVerticalColumnChart from '../charts/StatisticsVerticalColumnChart.vue';
  import StatisticsByTimeTabs from '../StatisticsByTimeTabs.vue';
  import StatisticsTabs from '../StatisticsTabs.vue';

  export default defineComponent({
    name: 'StatisticsPortalAverageVisitsTimeTabs',
    components: {
      StatisticsTabs,
      TableTree,
      StatisticsByTimeTabs,
      StatisticsVerticalColumnChart,
    },
    props: {
      filter: {
        type: Object as PropType<TStatisticsPortalFilter>,
        required: true,
      },
    },
    data(): {
      tableConfig: TTableTreeConfig<TPortalAverageVisitsTimeTableItem>;
      chartConfigs: TChartBaseConfig<TStatisticsPortalAverageVisitsTimeChartItem>;
    } {
      return {
        tableConfig: {
          columns: [
            {
              field: 'name',
              title: 'Период/Группа пользователей',
            },
            {
              field: 'averageVisitsTime',
              title: 'Среднее время',
              textAlign: 'right',
              width: 156,
            },
          ],
          storePaths: {
            action: STATISTICS_PORTAL_ACTIONS_NAME.getAverageVisitsTimeTable,
            mutation: STATISTICS_PORTAL_MUTATIONS_NAME.setAverageVisitsTimeTable,
            getter: STATISTICS_PORTAL_GETTERS_NAME.getAverageVisitsTimeTable,
          },
          pagination: {
            size: 12,
          },
        },
        chartConfigs: {
          storePaths: {
            action: STATISTICS_PORTAL_ACTIONS_NAME.getAverageVisitsTimeChartData,
            mutation: STATISTICS_PORTAL_MUTATIONS_NAME.setAverageVisitsTimeChartData,
            getter: STATISTICS_PORTAL_GETTERS_NAME.getAverageVisitsTimeChartData,
          },
          labelKey: 'label',
          tooltip: {
            key: 'text',
          },
          columns: [
            {
              name: 'Среднее время посещения',
              valueKey: 'averageVisitsTime',
            },
          ],
          lines: [
            {
              name: 'Среднее время посещения за весь период',
              valueKey: 'allAverageVisitsTime',
            },
          ],
        },
      };
    },
    methods: {
      formatLegendValue(value: number) {
        const hours = Math.floor(value / 3600);
        const minutes = Math.floor((value % 3600) / 60);
        const seconds = Math.floor(value % 60);
        const textHours = `${hours} ч`;
        const textMinutes = `${minutes} мин`;
        const textSeconds = `${seconds} сек`;

        if (hours && minutes && seconds) {
          return `${textHours} ${textMinutes} ${textSeconds}`;
        }

        if (hours && minutes) {
          return `${textHours} ${textMinutes}`;
        }

        if (hours && seconds) {
          return `${textHours} ${textSeconds}`;
        }

        if (hours) {
          return textHours;
        }

        if (minutes && seconds) {
          return `${textMinutes} ${textSeconds}`;
        }

        if (minutes) {
          return textMinutes;
        }

        return textSeconds;
      },
    },
  });
